module.exports = __webpack_public_path__ + "07_long_gold.d8390a9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/07_long_gold.png
// module id = 58s5
// module chunks = 0